/* @flow */
/**
 * Helpers for preparing purchase-order request bodies used by the conversation modal.
 */
/**
 * Ensures the source-system field is included when conversation modal PO data is requested.
 */
const setFieldSrcSysNm = (requestBody: Object) => {
  let updatedPayload = requestBody;
  // Add srcSysNm once so callers do not duplicate this required field.
  if (requestBody?.fields && !requestBody?.fields.includes('srcSysNm')) {
    updatedPayload = { ...requestBody, fields: [...requestBody.fields, 'srcSysNm'] };
  }
  return updatedPayload;
};

export default setFieldSrcSysNm;
